module.exports = __webpack_public_path__ + "static/media/body-parts.0b05bd29.png";